import { Directive, ElementRef, ChangeDetectorRef } from '@angular/core';

@Directive()
export class ViewPasswordComponentDef {
    protected isPasswordType = true;

    constructor(private elementRef: ElementRef, private changeDetectorRef: ChangeDetectorRef) {}

    toggle() {
        const inputs = (<HTMLElement>this.elementRef.nativeElement).getElementsByTagName('input');
        const input = inputs[0];

        if (input) {
            input.type = input.type === 'password' ? 'text' : 'password';
            this.isPasswordType = input.type === 'password';
            this.changeDetectorRef.detectChanges();
        }
    }
}
